<template>
    <price-tag-shell :context="context">
        <div class="two-groups pt-column">
            <div class="pt-row pt-row--top pt-row--between">
                <div class="pt-column two-groups__reward">
                    <div class="pt-headline">{{ tagText('save') }}</div>
                    <div class="pt-row two-groups__amount">
                        <span class="pt-big-number">
                            <price-tag-value v-bind="bindField('saveAmount')" />
                        </span>
                        <span class="pt-currency">{{ context.currencySymbol }}</span>
                    </div>
                    <div class="pt-medium">{{ tagText('onAnyProduct') }}</div>
                </div>
                <price-tag-discount :percent="firstTier.discountPercent" prefix="-" />
            </div>
            <div class="pt-column two-groups__requirements">
                <div class="pt-medium two-groups__requirement">
                    {{ tagText('buy') }}
                    <price-tag-value v-bind="bindField('groupABuy')" />
                    {{ tagText('onOfferGroup', { group: tagText('groupA') }) }}
                </div>
                <div class="pt-medium two-groups__requirement">
                    {{ tagText('buy') }}
                    <price-tag-value v-bind="bindField('groupBBuy')" />
                    {{ tagText('onOfferGroup', { group: tagText('groupB') }) }}
                </div>
            </div>
        </div>
    </price-tag-shell>
</template>

<script setup>
import { computed } from 'vue';
import {
    priceTagLayoutProps,
    priceTagLayoutEmits,
    usePriceTagLayout,
} from '@/js/composables/usePriceTagLayout';

const props = defineProps(priceTagLayoutProps);
const emit = defineEmits(priceTagLayoutEmits);

const { bindField, tagText } = usePriceTagLayout(props, emit);

const firstTier = computed(() => props.context.tiers[0] || {});
</script>

<style lang="scss" scoped>
@import '@style/price-tags/price-tag-layout';

.two-groups {
    justify-content: space-between;

    &__amount {
        align-items: flex-end;
    }

    &__requirements {
        border-top: 0.3rem solid currentColor;
        padding-top: 0.8rem;
        gap: 0.4rem;
    }

    &__requirement {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 0.6rem;
    }
}
</style>
